import { ThunkAction } from 'redux-thunk';
import * as Bixby from './../../core';
import { AppState } from './..';
import { RELEASE_FEATURE_FLAGS_LOADING, RELEASE_FEATURE_FLAGS_SUCCESS, RELEASE_FEATURE_FLAGS_FAILURE } from './types';
import { ReleaseFeatureFlagsService } from '$/services';

export const loadReleaseFeatureFlagsAction = () => {
  return {
    type: RELEASE_FEATURE_FLAGS_LOADING,
  };
};

export const releaseFeatureFlagsSuccessAction = (payload: Bixby.Models.ReleaseFeatureFlag[]) => {
  return {
    type: RELEASE_FEATURE_FLAGS_SUCCESS,
    payload,
  };
};

export const releaseFeatureFlagsFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: RELEASE_FEATURE_FLAGS_FAILURE,
    payload: error,
    error: true,
  };
};

// thunk actions

export const getReleaseFeatureFlags =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadReleaseFeatureFlagsAction());
    try {
      const result = await ReleaseFeatureFlagsService.getAll();
      dispatch(releaseFeatureFlagsSuccessAction(result));
    } catch (error: any) {
      dispatch(releaseFeatureFlagsFailureAction(error));
    }
  };
